import {AxiosError} from 'axios';

import {Completable, KashableResponseDTO, StringMapDTO} from 'kashable-mobile-common';

import {errored, mapSucceeded} from '../utils/AxiosUtils';

import axios from './base';

const fetchDictionary: () => Promise<Completable<StringMapDTO>> = () => {
    return axios
        .get<KashableResponseDTO<StringMapDTO>>('/secured/ui/lookup/dictionary')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

export {fetchDictionary};
